import { useAtomValue } from 'jotai';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { featureFlagsAtom } from './authenticated-app';
import ExplorePicker from './components/explore-picker/ExplorePicker';

import { StripesRegular, StripesProvider } from './components/stripes';

import { PageType } from './components/stripes/_utils/types';
import { Settings } from './pages/settings';
import { TvGuide } from './pages/tv-guide';
import { Developer } from './pages/developer-page';
import { Search } from './pages/search';

export const AuthenticatedRoutes: React.FC = () => {
  const featureFlags = useAtomValue(featureFlagsAtom);

  return (
    <Routes>
      <Route element={<TvGuide />} path="/tv-guide" />
      <Route element={<StripesRegular pageType={PageType.FrontPage} />} path="/" />
      <Route
        element={<StripesRegular pageType={PageType.Universe} />}
        path="/udforsk/universe/:universeTitle/:universeId"
      />
      <Route element={<Settings />} path="/settings" />
      <Route element={<Search />} path="/search" />
      {process.env.NODE_ENV === 'development' && (
        <Route element={<Developer />} path="/developer" />
      )}
      {featureFlags?.showUniverses && (
        <>
          <Route
            element={<StripesProvider pageType={PageType.ProviderUniverse} />}
            path="/provideruniverse/:universeTitle/:providerId"
          />
          <Route element={<ExplorePicker />} path="/udforsk" />
        </>
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AuthenticatedRoutes;
